<template>
    <div>
        <v-row class="noprint">
            <v-col cols="9">
                <h1 class="headline font-weight-light mb-3">
                    <span class="link-a cur-p" @click="back()">
                        RETURN DEFECTIVE PARTS</span
                    >
                    / PRINT
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="3" class="text-right ">
                <v-btn rounded small @click="print()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print</v-btn
                >
            </v-col>
        </v-row>
        <v-switch v-model="is_logo" class="ma-1 pa-3"></v-switch>
        <div id="printDiv">
            <div class="mt-3">
                <div>
                    <div>
                        <table width="10%" style="float:left;">
                            <tr>
                                <td
                                    v-if="
                                        emp_id == 'P08-044' ||
                                            emp_id == ' P23-031'
                                    "
                                >
                                    <img
                                        v-if="is_logo == false"
                                        src="../../assets/return/HPBLACK.png"
                                        alt="Smiley face"
                                        height="50"
                                        width="50"
                                    />
                                    <img
                                        v-if="is_logo == true"
                                        src="../../assets/logistic/Acacia.jpg"
                                        alt="Smiley face"
                                        height="80"
                                        width="80"
                                    />
                                </td>
                                <td v-else>
                                    <img
                                        src="../../assets/logistic/Acacia.jpg"
                                        alt="Smiley face"
                                        height="80"
                                        width="80"
                                    />
                                </td>
                            </tr>
                        </table>

                        <table width="84%">
                            <tr align="center">
                                <td colspan="6">
                                    <span
                                        align="center"
                                        style="font-size: 17px;font-weight:bold;"
                                        >RETURN DEFECTIVE PARTS</span
                                    >
                                </td>
                            </tr>
                            <tr align="center">
                                <td colspan="6"></td>
                            </tr>
                            <tr>
                                <td width="25%" align="right">
                                    DELIVER TO LOGISTICS BY:
                                </td>
                                <td
                                    width="25%"
                                    style="border-bottom: 1px solid #000;"
                                >
                                    {{ data_print.branch_min }}
                                </td>
                                <td width="9%" align="right">DATE:</td>
                                <td
                                    width="23%"
                                    style="border-bottom: 1px solid #000;"
                                >
                                    {{ data_print.create_date }}
                                </td>
                                <td width="10%" align="right">ACA-NO:</td>
                                <td
                                    width="14%"
                                    style="border-bottom: 1px solid #000;"
                                >
                                    {{ data_print.return_no }}
                                </td>
                            </tr>
                        </table>

                        <table width="23%">
                            <tr>
                                <td width="30%">SITE NO:</td>
                                <td
                                    width="70%"
                                    style="border-bottom: 1px solid #000;"
                                ></td>
                            </tr>
                            <tr>
                                <td>BADGE NO:</td>
                                <td style="border-bottom: 1px solid #000;"></td>
                            </tr>
                        </table>
                    </div>
                    <br />
                    <div align="center">
                        <table cellpadding="7" width="100%" border="1">
                            <tr align="center">
                                <td width="3%"><b>Item</b></td>
                                <td width="4%"><b>QTY</b></td>
                                <td width="9%"><b>Part No.</b></td>
                                <td width="32%"><b>Description</b></td>
                                <td width="12%"><b>Case No.</b></td>
                                <td width="6%"><b>Charge Code</b></td>
                                <td width="14%"><b>Customer Name</b></td>
                                <td width="4%"><b>Option</b></td>
                                <td width="4%"><b>Consumption Reason</b></td>
                                <td width="3%"><b>Trans Typs</b></td>
                                <td width="10%"><b>Red Tag No.</b></td>
                            </tr>

                            <tr
                                v-for="(row, index) in data_print.parts"
                                :key="index"
                            >
                                <td align="center">{{ index + 1 }}.</td>
                                <td align="center">1</td>
                                <td align="center">{{ row.part_name }}</td>
                                <td>{{ row.part_description }}</td>
                                <td align="center">{{ row.ponumber }}</td>
                                <td align="center">F</td>
                                <td align="center">{{ row.singlepart }}</td>
                                <td></td>
                                <td align="center">CM</td>
                                <td align="center">{{ row.tran_type }}</td>
                                <td></td>
                            </tr>
                        </table>

                        <br />

                        <table width="20%" style="float:left">
                            <tr>
                                <td>Sender:</td>
                                <td
                                    style="border-bottom: 1px solid #000;width: 110px;"
                                >
                                    {{ data_print.create_name }}
                                </td>
                            </tr>
                            <!-- <tr>
                                <td>Receiver:</td>
                                <td style="border-bottom: 1px solid #000;"></td>
                            </tr> -->
                            <tr>
                                <td>Date:</td>
                                <td style="border-bottom: 1px solid #000;">
                                    {{ data_print.create_date }}
                                </td>
                            </tr>
                            <tr>
                                <td>Time:</td>
                                <td style="border-bottom: 1px solid #000;">
                                    {{ data_print.create_time }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    mounted() {
        this.return_no = this.$route.params.return_no
        this.get_data()
    },
    methods: {
        async get_data() {
            await axios
                .get(url + "engineer/return-no/" + this.return_no)
                .then((response) => {
                    // console.log(response)
                    this.data_print = response.data[0]
                    // console.log(this.data_print)
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        back() {
            if (this.role_type == "Engineer") {
                this.$router.push("/Onsite/Main/Return-Part")
            } else {
                this.$router.push("/Return-Part")
            }
        },
        print() {
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    "https://aitt.netlify.app/landscape.css",
                ],
            }

            this.$htmlToPaper("printDiv", localOptions, () => {
                // console.log(localOptions)
                // console.warn("done landscape")
            })
        },
    },
    data() {
        return {
            is_logo: true,
            return_no: 0,
            data_print: [],
            role_type: localStorage.role_type,
            emp_id: localStorage.emp_img,
        }
    },
}
</script>
